const getNodeOffset = ( node ) => {
	let top = 0;
	let left = 0;
	
	if ( node )
	{
		const rect = node.getBoundingClientRect();
		const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		
		top = rect.top + scrollTop;
		left = rect.left + scrollLeft;
	}
	
	return {top, left};
};

const getScrollWidth = () => {
	return window.innerWidth - document.documentElement.clientWidth;
};

const isSelectorValid = ( selector ) => {
	if ( selector )
	{
		const fakeNode = document.createDocumentFragment();
		
		try {
			fakeNode.querySelector( selector );
		}
		catch
		{
			return false;
		}
		
		return true;
	}
	
	return false;
};

const animate = ( {timing, draw, duration, cancelCallback = () => false} ) => {
	const start = performance.now();
	
	const animateFraction = ( time ) => {
		let timeFraction = ( time - start ) / duration;
		if ( timeFraction > 1 )
		{
			timeFraction = 1;
		}
		
		const progress = timing( timeFraction );
		
		draw( progress );
		
		if ( timeFraction < 1 )
		{
			const requestId = window.requestAnimationFrame( animateFraction );
			
			if ( cancelCallback() )
			{
				window.cancelAnimationFrame( requestId );
			}
		}
	};
	
	window.requestAnimationFrame( animateFraction );
};

const createNode = ( template ) => {
	const wrapper = document.createElement( 'div' );
	wrapper.innerHTML = template;
	
	return wrapper.firstElementChild;
};

export {
	getNodeOffset,
	isSelectorValid,
	animate,
	createNode,
	getScrollWidth,
};
